import React, { useEffect, useState } from "react";
import { Image } from "antd";

const loadProtectedFile = async (documentId, download = false) => {
    const token = localStorage.getItem("token");
    const suffix = download ? "?download=1" : "";
    const response = await fetch(`/api/documents/${documentId}/file${suffix}`, {
        headers: { Authorization: `Bearer ${token}` }
    });
    if (!response.ok) throw new Error("文件读取失败");
    return response.blob();
};

export const downloadProtectedFile = async document => {
    const blob = await loadProtectedFile(document.id, true);
    const url = URL.createObjectURL(blob);
    const link = window.document.createElement("a");
    link.href = url;
    link.download = document.file_name || "下载文件";
    window.document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
};

export const ProtectedFileLink = ({ document, children = "下载文件" }) => (
    <a href="#download" onClick={async event => {
        event.preventDefault();
        try { await downloadProtectedFile(document); } catch (error) { window.alert("文件读取失败，请重新登录后再试"); }
    }}>{children}</a>
);

export const ProtectedImage = ({ document, alt, style, preview = false }) => {
    const [src, setSrc] = useState("");

    useEffect(() => {
        let active = true;
        let objectUrl = "";
        loadProtectedFile(document.id).then(blob => {
            objectUrl = URL.createObjectURL(blob);
            if (active) setSrc(objectUrl);
        }).catch(() => {
            if (active) setSrc("");
        });
        return () => {
            active = false;
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [document.id]);

    if (!src) return <span style={{ color: "#8c8c8c" }}>图片加载中...</span>;
    return <Image src={src} alt={alt} style={{ ...style, cursor: preview ? "zoom-in" : style?.cursor }} preview={preview ? { mask: "点击放大" } : false} />;
};

export const ProtectedImagePreviewGroup = Image.PreviewGroup;
